import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { GitMerge, Undo2 } from "lucide-react";

const LINK = { notizia: (id) => `/notizie/${id}`, immobile: (id) => `/immobili/${id}`, acquirente: (id) => `/acquirenti?open=${id}` };

export async function ripristinaUnione(tipo, id) {
  if (!window.confirm("Ripristinare questa scheda? Tornerà attiva con i suoi appuntamenti e documenti.")) return false;
  try { await api.post("/clienti/unisci/ripristina", { tipo, drop_id: id }); toast.success("Scheda ripristinata"); return true; }
  catch (e) { toast.error(e.response?.data?.detail || "Errore nel ripristino"); return false; }
}

export function UnitoInfo({ tipo, id, unitaIn, unitaInNome, onRestored }) {
  const nav = useNavigate();
  const { isDirezione } = useAuth();
  return (
    <div className="flex items-center gap-2 flex-wrap text-sm">
      <GitMerge size={15} className="text-[#b84fae]" />
      <span>Unito in →</span>
      <button data-testid={`unito-link-${id}`} onClick={() => nav(LINK[tipo](unitaIn))} className="font-semibold text-[#b84fae] underline underline-offset-2">{unitaInNome || "scheda principale"}</button>
      {isDirezione && (
        <button data-testid={`unito-ripristina-${id}`} onClick={async () => { if (await ripristinaUnione(tipo, id)) onRestored && onRestored(); }}
          className="ml-auto flex items-center gap-1 px-2.5 py-1.5 rounded-lg bg-white border border-[var(--border)] text-xs font-semibold hover:border-[#FC82ED]"><Undo2 size={13} /> Ripristina</button>
      )}
    </div>
  );
}

export default function UnitoBanner({ tipo, rec, onRestored }) {
  if (!rec?.unita_in) return null;
  return (
    <div data-testid="unito-banner" className="mb-4 p-3.5 rounded-2xl border-2 border-[#FC82ED]/40 bg-[#FC82ED]/5">
      <div className="text-[11px] font-bold uppercase tracking-wider text-[var(--muted)] mb-1">Scheda archiviata (doppione unito)</div>
      <UnitoInfo tipo={tipo} id={rec.id} unitaIn={rec.unita_in} unitaInNome={rec.unita_in_nome} onRestored={onRestored} />
    </div>
  );
}
